import { defineStore } from "pinia";

export const useStore = defineStore("main", {
  state: () => ({
    keepLiiveRoute: [],
    TeacherType: ''
  }),
  getters: {
    tzxxInfo: (state) => {
      // state.tzxx = JSON.parse(getStorage("tzxx"));
      // return state.tzxx;
    },
  },
  actions: {
    changeTeacherType(val) {
      this.$patch({ TeacherType: val });
    },
    setKeepLiiveRoute(val) {
      this.keepLiiveRoute.push(val);
    },
    deleteKeepLiiveRoute(val) {
      this.keepLiiveRoute = this.keepLiiveRoute.filter((item) => {
        return item != val;
      });
    },
  },
});

